const { isInteger } = Number;

export { isInteger };
